import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'https://tamratdates.com';

// Per-page <head> manager. Owns title / description / Open Graph / Twitter /
// canonical and (optionally) page-specific JSON-LD structured data, so each
// route presents accurate metadata to Google, social, and AI search engines.
const Meta = ({ title, description, keywords, image, url, type, schema }) => {
  const fullImage = image || `${SITE}/logo.webp`;
  // Self-canonical per route: use an explicit url prop if given, else the
  // current path on the production origin (window.location.pathname is correct
  // during react-snap prerender and at runtime; SITE keeps the prod origin).
  const path =
    (typeof window !== 'undefined' && window.location && window.location.pathname) || '/';
  const canonical = url || SITE + (path === '/' ? '' : path);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keywords' content={keywords} />
      <link rel='canonical' href={canonical} />

      {/* Open Graph */}
      <meta property='og:type' content={type || 'website'} />
      <meta property='og:site_name' content='تمرات | Tamrat Dates' />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:image' content={fullImage} />
      <meta property='og:url' content={canonical} />
      <meta property='og:locale' content='ar_AR' />

      {/* Twitter */}
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content={fullImage} />

      {/* Structured data (per page) */}
      {schema && (
        <script type='application/ld+json'>{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'تمرات | تمور سعودية فاخرة — سكري، عجوة، مجدول، مبروم | اشترِ أونلاين',
  description:
    'نقدم تشكيلة واسعة من التمور السعودية الأصلية بجودة عالية: سكري، عجوة المدينة، مجدول، مبروم، صقعي. تسوّق أونلاين مع توصيل سريع وشحن مجاني للطلبات فوق 250 ر.س.',
  keywords:
    'تمرات, تمر عجوة, عجوة المدينة, تمر صقعي, تمر سكري, تمر مجدول, تمر مجهول, تمور طازجة, تمور, تمر مبروم, شراء تمور اونلاين, افضل تمور السعودية, tamrat, tamrat dates, tamratdates, buy dates online saudi arabia',
};

export default Meta;
